import React from 'react';

export const DivorceTextMin = () => {
  return (
    <>
      <p>Що входить в роботу:</p>
      <p>✔️консультації на всьому етапі справи(тел.);</p>
      <p>
        ✔️підготовка позовної заяви (відправка новою поштою або на електронну
        адресу);
      </p>
      <p>✔️інструкція, як подати документи і що робити далі в суді.</p>
    </>
  );
};
